import {FreeSpinsIntroState, GenericPopupEvents, GenericPopupType} from '@gongxigames/framework/slot';
import {GameLogic} from 'src/server/GameLogic';

export class GameFreeSpinsIntroState extends FreeSpinsIntroState {
    public onEnterState(): void {
        const logic = this.module.logic as GameLogic;
        const type = GenericPopupType.FREESPIN_INTRO;
        const fgBonus = logic.getFreeGames();

        this.module.soundPlayer.playMusic('freegamewaitingloop');
        this.emit(GenericPopupEvents.SHOW_POPUP, type, this.module.getValueByType(type), fgBonus.getFreeGameType());
    }
}
